import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../lib/dataService';

const FALLBACK_IMG = '/media/uploads/2023/12/5d3a86e0-8698-43d8-8d99-20bfb54dbcc8.webp';

export default function NewsCard({ post, size = 'normal' }) {
  return (
    <Link to={`/news/${post.slug}`} className={`news-card ${size}`}>
      <div className="news-card-img">
        <img src={post.image || FALLBACK_IMG} alt={post.title} loading="lazy" />
        {post.categories && post.categories[0] && (
          <span className="news-card-cat">{post.categories[0]}</span>
        )}
      </div>
      <div className="news-card-body">
        <span className="news-card-date">{formatDate(post.date)}</span>
        <h3 className="news-card-title">{post.title}</h3>
        {size !== 'compact' && <p className="news-card-excerpt">{post.excerpt}</p>}
      </div>
    </Link>
  );
}
